import { assertEvent, assign, type ActionArgs } from 'xstate5';

import { getDefaultPaymentMethodId } from '../utils';
import { type ScanToPayContext } from './scan-to-pay.machine.context';
import { type ScanToPayEvents } from './scan-to-pay.machine.events';

// ─── Actions ─────────────────────────────────────────────────────────────────

const onFetchDataDone: ScanToPayAction = assign({
  availablePoints({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchData');
    return event.output.availablePoints;
  },
  availableCredit({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchData');
    return event.output.availableCredit;
  },
  paymentMethods({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchData');
    return event.output.paymentMethods;
  },
  pointsRewards({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchData');
    return event.output.pointsRewards;
  },
  paymentMethodId({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchData');
    return getDefaultPaymentMethodId(event.output.paymentMethods);
  },
});

const onFetchIdentifyTokenDone: ScanToPayAction = assign({
  identifyToken({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchIdentifyToken');
    return event.output.identifyToken;
  },
});

const onFetchPaymentTokenDone: ScanToPayAction = assign({
  paymentToken({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchPaymentToken');
    return event.output.paymentToken;
  },
});

const onFetchCreditsDone: ScanToPayAction = assign({
  availableCredit({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchCredits');
    return event.output.availableCredit;
  },
});

const onSwitchUseCredit: ScanToPayAction = assign(({ context }) => ({
  useCredit: !context.useCredit,
}));

export const ScanToPayActions = {
  onFetchDataDone,
  onFetchIdentifyTokenDone,
  onFetchPaymentTokenDone,
  onFetchCreditsDone,
  onSwitchUseCredit,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayAction<ActionParams extends Record<string, unknown> | void = void> = (
  actionArgs: ActionArgs<ScanToPayContext, ScanToPayEvents, ScanToPayEvents>,
  params: ActionParams,
) => void;
